import { h } from '@/lib/dom';
import { formatDate } from '@/lib/format';

export interface EventFlagProps {
  kind: string;
  title: string;
  date: string;
  details?: string | null;
}

export function eventIcon(kind: string): string {
  if (kind === 'med_start' || kind === 'med_stop' || kind === 'med_change') return '⚑';
  if (kind === 'illness' || kind === 'lifestyle' || kind === 'diet_change') return '✽';
  return '◆';
}

export function EventFlag(props: EventFlagProps): HTMLElement {
  const ariaLabel = `${formatDate(props.date)}, ${props.title}${props.details ? `, ${props.details}` : ''}`;
  return h('div', { class: 'event-flag', aria: { label: ariaLabel } }, [
    h('span', { 'aria-hidden': 'true', class: 'event-icon' }, eventIcon(props.kind) + ' '),
    h('span', { class: 'event-date' }, formatDate(props.date) + ' '),
    h('span', { class: 'event-title' }, props.title),
  ]);
}
